/*
 * @Author: your name
 * @Date: 2021-08-20 09:33:26
 * @LastEditTime: 2021-10-22 13:51:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/study/mathematics/api.ts
 */
import { CheckboxOptionType } from 'antd';
import { fiveTypeAdd, fiveTypeSubtr } from './action';
import * as methods from './action';

// export const details =[]
// 81/ 82/9+1 四则运算带（）| 2000>X>100  二下
// 2000>X>100 +- | 1000>1 * 三上
// 1000>1 / | 100>10 *  | 10.0 +- 三下
// 10000>100 *  10000/100 = <100  四上
// 100.00> 0.00 +- 四下

export const addAndSub = ['+', '-'];

export type Calculate = ''
// const 

// export const courses: { [proppName: string]: string } = {
//     class1Up: '一年级上',
//     class1Dow: '一年级上',
//     class2Up: '二年级上',
//     class2Dow: '二年级下',
//     class3Up: '三年级上',
//     class3Dow: '三年级下',
//     class4Up: '四年级上',
//     class4Dow: '四年级下',
// }

export const courses = [
    { label: '一年级上', value: 'class1Up' },
    { label: '一年级下', value: 'class1Dow' },
    { label: '二年级上', value: 'class2Up' },
    { label: '二年级下', value: 'class2Dow' },
    { label: '三年级上', value: 'class3Up' },
    { label: '三年级下', value: 'class3Dow' },
    { label: '四年级上', value: 'class4Up' },
    { label: '四年级下', value: 'class4Dow' },
];


export const question: { [proppName: string]: Array<CheckboxOptionType> } = {
    'class1Up': [
        { label: '5以内加减法', value: 'class1Up_1' },
        { label: '10以内加减法', value: 'class1Up_2' },
        { label: '20以内加法', value: 'class1Up_3' },
    ],
    'class1Dow': [
        { label: '20以内减法', value: 'class1Dow_1' },
        { label: '100加减法', value: 'class1Dow_2' },
    ],
    'class2Up': [
        { label: '100以内加减混合运算', value: 'class2Up_1' },
        { label: '99乘法表', value: 'class2Up_2' },
    ],
    'class2Dow': [
        { label: '81以内除法', value: 'class2Dow_1' },
        { label: '除法余数计算', value: 'class2Dow_2' },
        { label: '四则运算', value: 'class2Dow_3' },
        { label: '整百整千加减法', value: 'class2Dow_4' },
    ],
    'class3Up': [
        { label: '万以内加减法', value: 'class3Up_1' },
        { label: '多位数乘1位数', value: 'class3Up_2' },
        { label: '简单分数运算', value: 'class3Up_3' },
    ],
    'class3Dow': [
        { label: '多位数除1位数', value: 'class3Dow_1' },
        { label: '两位乘两位', value: 'class3Dow_2' },
        { label: '简单小数加减法（37内）', value: 'class3Dow_3' },
    ],
    'class4Up': [
        { label: '三位数乘两位数', value: 'class4Up_1' },
        { label: '除数是两位数除法', value: 'class4Up_2' },
    ],
    'class4Dow': [
        { label: '小数的加减法（后两位）', value: 'class4Dow_1' }
    ]
}

export function submit(obj: { totalNum: number, topic: Array<string> }) {
    let questionBank: string[] = [];
    let topic = obj.topic;
    let meanValue = obj.totalNum / topic.length + 1;
    topic && topic.map(item => {
        switch (item) {
            case 'class1Up_1':
                questionBank.push(...methods.toAndSubtractIn5(meanValue));
                break;
            case 'class1Up_2':
                questionBank.push(...methods.toAndSubtractIn10(meanValue));
                break;
            case 'class1Up_3':
                questionBank.push(...methods.toAndSubtractIn20(meanValue, fiveTypeAdd));
                break;
            case 'class1Dow_1':
                questionBank.push(...methods.toAndSubtractIn20(meanValue, fiveTypeSubtr));
                break;
            case 'class1Dow_2':
                questionBank.push(...methods.toAndSubtractIn100(meanValue));
                break;
            case 'class2Up_1':
                questionBank.push(...methods.toAndSubtractIn100Mixture(meanValue));
                break;
            case 'class2Up_2':
                questionBank.push(...methods.multiplicationTables(meanValue));
                break;
            case 'class2Dow_1':
                questionBank.push(...methods.divisionTables(meanValue));
                break;
            case 'class2Dow_2':
                questionBank.push(...methods.divisionTablesRemainder(meanValue));
                break;
            case 'class2Dow_3':
                questionBank.push(...methods.mixedOperation(meanValue));
                break;
            case 'class2Dow_4':
                questionBank.push(...methods.integerMath(meanValue));
                break;
            case 'class3Up_1':
                questionBank.push(...methods.thousandWithin(meanValue));
                break;
            case 'class3Up_2':
                questionBank.push(...methods.moreTake1(meanValue));
                break;
            case 'class3Up_3':
                questionBank.push(...methods.scoreMath(meanValue));
                break;
            case 'class3Dow_1':
                questionBank.push(...methods.divisionTake1(meanValue));
                break;
            case 'class3Dow_2':
                questionBank.push(...methods.moreTakeN(meanValue));
                break;
            case 'class3Dow_3':
                questionBank.push(...methods.decimalMeath(meanValue));
                break;
            case 'class4Up_1':
                questionBank.push(...methods.thereTake2(meanValue));
                break;
            case 'class4Up_2':
                questionBank.push(...methods.divisionTake2(meanValue));
                break;
            case 'class4Dow_1':
                questionBank.push(...methods.decimal2(meanValue));
                break;
            default:
                break;
        }
    })
    return methods.shuffle(questionBank).splice(0, obj.totalNum);
}

